module.exports = __webpack_public_path__ + "static/media/18ECA26.274ee904.jpg";